function n(n,r){return!!r&&(t=Array.isArray(r)?r.map((function(n){return".".concat(n)})).join(","):".".concat(r),!!n.parentElement.closest(t));var t}export{n as isInsideClass};
